import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "js-page-content",
  role: "main",
  class: "page-content"
}
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<ol class=\"breadcrumb page-breadcrumb\"><li class=\"breadcrumb-item\"><a href=\"javascript:void(0);\">SmartAdmin</a></li><li class=\"breadcrumb-item\">Category</li><li class=\"breadcrumb-item\">Sub-category</li><li class=\"breadcrumb-item active\">Page Title</li><li class=\"position-absolute pos-top pos-right d-none d-sm-block\"><span class=\"js-get-date\"></span></li></ol><div class=\"subheader\"><h1 class=\"subheader-title\"><i class=\"subheader-icon fal fa-globe\"></i> Loader <span class=\"fw-300\">サンプル</span><sup class=\"badge badge-primary fw-500\">STICKER</sup><small> Insert page description or punch line </small></h1><div class=\"subheader-block\">Right Subheader Block</div></div><div class=\"alert alert-primary\"><div class=\"d-flex flex-start w-100\"><div class=\"mr-2 hidden-md-down\"><span class=\"icon-stack icon-stack-lg\"><i class=\"base base-6 icon-stack-3x opacity-100 color-primary-500\"></i><i class=\"base base-10 icon-stack-2x opacity-100 color-primary-300 fa-flip-vertical\"></i><i class=\"ni ni-blog-read icon-stack-1x opacity-100 color-white\"></i></span></div><div class=\"d-flex flex-fill\"><div class=\"flex-fill\"><span class=\"h5\">注意事項!</span><p>特に注意事項はないです</p><p class=\"m-0\"> Follow a slogal with a useful link or call to action <a href=\"#\" target=\"_blank\">Call to action &gt;&gt;</a></p></div></div></div></div>", 3)
const _hoisted_5 = { class: "row" }
const _hoisted_6 = { class: "col-md-6" }
const _hoisted_7 = {
  id: "panel-x",
  class: "panel"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "panel-hdr" }, [
  /*#__PURE__*/_createElementVNode("h2", null, "button"),
  /*#__PURE__*/_createElementVNode("div", { class: "panel-toolbar" }, [
    /*#__PURE__*/_createElementVNode("button", {
      class: "btn btn-panel waves-effect waves-themed",
      "data-action": "panel-collapse",
      "data-toggle": "tooltip",
      "data-offset": "0,10",
      "data-original-title": "Collapse"
    }),
    /*#__PURE__*/_createElementVNode("button", {
      class: "btn btn-panel waves-effect waves-themed",
      "data-action": "panel-fullscreen",
      "data-toggle": "tooltip",
      "data-offset": "0,10",
      "data-original-title": "Fullscreen"
    }),
    /*#__PURE__*/_createElementVNode("button", {
      class: "btn btn-panel waves-effect waves-themed",
      "data-action": "panel-close",
      "data-toggle": "tooltip",
      "data-offset": "0,10",
      "data-original-title": "Close"
    })
  ]),
  /*#__PURE__*/_createElementVNode("div", {
    class: "panel-toolbar",
    role: "menu"
  }, [
    /*#__PURE__*/_createElementVNode("a", {
      href: "#",
      class: "btn btn-toolbar-master waves-effect waves-themed",
      "data-toggle": "dropdown"
    }, [
      /*#__PURE__*/_createElementVNode("i", { class: "fal fa-ellipsis-v" })
    ]),
    /*#__PURE__*/_createElementVNode("div", { class: "dropdown-menu dropdown-menu-animated dropdown-menu-right p-0" }, [
      /*#__PURE__*/_createElementVNode("a", {
        href: "#",
        class: "dropdown-item js-panel-refresh"
      }, [
        /*#__PURE__*/_createElementVNode("span", { "data-i18n": "drpdwn.refreshpanel" }, "Refresh Content")
      ]),
      /*#__PURE__*/_createElementVNode("a", {
        href: "#",
        class: "dropdown-item js-panel-locked"
      }, [
        /*#__PURE__*/_createElementVNode("span", { "data-i18n": "drpdwn.lockpanel" }, "Lock Position")
      ]),
      /*#__PURE__*/_createElementVNode("div", { class: "dropdown-multilevel dropdown-multilevel-left" }, [
        /*#__PURE__*/_createElementVNode("div", { class: "dropdown-item" }, [
          /*#__PURE__*/_createElementVNode("span", { "data-i18n": "drpdwn.panelcolor" }, "Panel Style")
        ]),
        /*#__PURE__*/_createElementVNode("div", {
          class: "dropdown-menu d-flex flex-wrap",
          style: {"min-width":"9.5rem","width":"9.5rem","padding":"0.5rem"}
        }, [
          /*#__PURE__*/_createElementVNode("a", {
            href: "#",
            class: "btn d-inline-block bg-primary-700 bg-success-gradient width-2 height-2 p-0 rounded-0 js-panel-color hover-effect-dot waves-effect waves-themed",
            "data-panel-setstyle": "bg-primary-700 bg-success-gradient",
            style: {"margin":"1px"}
          }),
          /*#__PURE__*/_createElementVNode("a", {
            href: "#",
            class: "btn d-inline-block bg-primary-500 bg-info-gradient width-2 height-2 p-0 rounded-0 js-panel-color hover-effect-dot waves-effect waves-themed",
            "data-panel-setstyle": "bg-primary-500 bg-info-gradient",
            style: {"margin":"1px"}
          }),
          /*#__PURE__*/_createElementVNode("a", {
            href: "#",
            class: "btn d-inline-block bg-primary-600 bg-primary-gradient width-2 height-2 p-0 rounded-0 js-panel-color hover-effect-dot waves-effect waves-themed",
            "data-panel-setstyle": "bg-primary-600 bg-primary-gradient",
            style: {"margin":"1px"}
          }),
          /*#__PURE__*/_createElementVNode("a", {
            href: "#",
            class: "btn d-inline-block bg-info-600 bg-primray-gradient width-2 height-2 p-0 rounded-0 js-panel-color hover-effect-dot waves-effect waves-themed",
            "data-panel-setstyle": "bg-info-600 bg-primray-gradient",
            style: {"margin":"1px"}
          }),
          /*#__PURE__*/_createElementVNode("a", {
            href: "#",
            class: "btn d-inline-block bg-info-600 bg-info-gradient width-2 height-2 p-0 rounded-0 js-panel-color hover-effect-dot waves-effect waves-themed",
            "data-panel-setstyle": "bg-info-600 bg-info-gradient",
            style: {"margin":"1px"}
          }),
          /*#__PURE__*/_createElementVNode("a", {
            href: "#",
            class: "btn d-inline-block bg-info-700 bg-success-gradient width-2 height-2 p-0 rounded-0 js-panel-color hover-effect-dot waves-effect waves-themed",
            "data-panel-setstyle": "bg-info-700 bg-success-gradient",
            style: {"margin":"1px"}
          }),
          /*#__PURE__*/_createElementVNode("a", {
            href: "#",
            class: "btn d-inline-block bg-success-900 bg-info-gradient width-2 height-2 p-0 rounded-0 js-panel-color hover-effect-dot waves-effect waves-themed",
            "data-panel-setstyle": "bg-success-900 bg-info-gradient",
            style: {"margin":"1px"}
          }),
          /*#__PURE__*/_createElementVNode("a", {
            href: "#",
            class: "btn d-inline-block bg-success-700 bg-primary-gradient width-2 height-2 p-0 rounded-0 js-panel-color hover-effect-dot waves-effect waves-themed",
            "data-panel-setstyle": "bg-success-700 bg-primary-gradient",
            style: {"margin":"1px"}
          }),
          /*#__PURE__*/_createElementVNode("a", {
            href: "#",
            class: "btn d-inline-block bg-success-600 bg-success-gradient width-2 height-2 p-0 rounded-0 js-panel-color hover-effect-dot waves-effect waves-themed",
            "data-panel-setstyle": "bg-success-600 bg-success-gradient",
            style: {"margin":"1px"}
          }),
          /*#__PURE__*/_createElementVNode("a", {
            href: "#",
            class: "btn d-inline-block bg-danger-900 bg-info-gradient width-2 height-2 p-0 rounded-0 js-panel-color hover-effect-dot waves-effect waves-themed",
            "data-panel-setstyle": "bg-danger-900 bg-info-gradient",
            style: {"margin":"1px"}
          }),
          /*#__PURE__*/_createElementVNode("a", {
            href: "#",
            class: "btn d-inline-block bg-fusion-400 bg-fusion-gradient width-2 height-2 p-0 rounded-0 js-panel-color hover-effect-dot waves-effect waves-themed",
            "data-panel-setstyle": "bg-fusion-400 bg-fusion-gradient",
            style: {"margin":"1px"}
          }),
          /*#__PURE__*/_createElementVNode("a", {
            href: "#",
            class: "btn d-inline-block bg-faded width-2 height-2 p-0 rounded-0 js-panel-color hover-effect-dot waves-effect waves-themed",
            "data-panel-setstyle": "bg-faded",
            style: {"margin":"1px"}
          })
        ])
      ]),
      /*#__PURE__*/_createElementVNode("div", { class: "dropdown-divider m-0" }),
      /*#__PURE__*/_createElementVNode("a", {
        href: "#",
        class: "dropdown-item js-panel-reset"
      }, [
        /*#__PURE__*/_createElementVNode("span", { "data-i18n": "drpdwn.resetpanel" }, "Reset Panel")
      ])
    ])
  ])
], -1)
const _hoisted_9 = { class: "panel-container show" }
const _hoisted_10 = { class: "panel-content" }
const _hoisted_11 = { class: "frame-wrap" }
const _hoisted_12 = { class: "demo" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "panel-tag" }, " ボタンを押すとボタンが無効になり、処理が終わると再度ボタンが有効になる。 ", -1)
const _hoisted_14 = { class: "col-md-6" }
const _hoisted_15 = {
  id: "panel-x",
  class: "panel"
}
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "panel-hdr" }, [
  /*#__PURE__*/_createElementVNode("h2", null, "panel"),
  /*#__PURE__*/_createElementVNode("div", { class: "panel-toolbar" }, [
    /*#__PURE__*/_createElementVNode("button", {
      class: "btn btn-panel waves-effect waves-themed",
      "data-action": "panel-collapse",
      "data-toggle": "tooltip",
      "data-offset": "0,10",
      "data-original-title": "Collapse"
    }),
    /*#__PURE__*/_createElementVNode("button", {
      class: "btn btn-panel waves-effect waves-themed",
      "data-action": "panel-fullscreen",
      "data-toggle": "tooltip",
      "data-offset": "0,10",
      "data-original-title": "Fullscreen"
    }),
    /*#__PURE__*/_createElementVNode("button", {
      class: "btn btn-panel waves-effect waves-themed",
      "data-action": "panel-close",
      "data-toggle": "tooltip",
      "data-offset": "0,10",
      "data-original-title": "Close"
    })
  ]),
  /*#__PURE__*/_createElementVNode("div", {
    class: "panel-toolbar",
    role: "menu"
  }, [
    /*#__PURE__*/_createElementVNode("a", {
      href: "#",
      class: "btn btn-toolbar-master waves-effect waves-themed",
      "data-toggle": "dropdown"
    }, [
      /*#__PURE__*/_createElementVNode("i", { class: "fal fa-ellipsis-v" })
    ]),
    /*#__PURE__*/_createElementVNode("div", { class: "dropdown-menu dropdown-menu-animated dropdown-menu-right p-0" }, [
      /*#__PURE__*/_createElementVNode("a", {
        href: "#",
        class: "dropdown-item js-panel-refresh"
      }, [
        /*#__PURE__*/_createElementVNode("span", { "data-i18n": "drpdwn.refreshpanel" }, "Refresh Content")
      ]),
      /*#__PURE__*/_createElementVNode("a", {
        href: "#",
        class: "dropdown-item js-panel-locked"
      }, [
        /*#__PURE__*/_createElementVNode("span", { "data-i18n": "drpdwn.lockpanel" }, "Lock Position")
      ]),
      /*#__PURE__*/_createElementVNode("div", { class: "dropdown-multilevel dropdown-multilevel-left" }, [
        /*#__PURE__*/_createElementVNode("div", { class: "dropdown-item" }, [
          /*#__PURE__*/_createElementVNode("span", { "data-i18n": "drpdwn.panelcolor" }, "Panel Style")
        ]),
        /*#__PURE__*/_createElementVNode("div", {
          class: "dropdown-menu d-flex flex-wrap",
          style: {"min-width":"9.5rem","width":"9.5rem","padding":"0.5rem"}
        }, [
          /*#__PURE__*/_createElementVNode("a", {
            href: "#",
            class: "btn d-inline-block bg-primary-700 bg-success-gradient width-2 height-2 p-0 rounded-0 js-panel-color hover-effect-dot waves-effect waves-themed",
            "data-panel-setstyle": "bg-primary-700 bg-success-gradient",
            style: {"margin":"1px"}
          }),
          /*#__PURE__*/_createElementVNode("a", {
            href: "#",
            class: "btn d-inline-block bg-primary-500 bg-info-gradient width-2 height-2 p-0 rounded-0 js-panel-color hover-effect-dot waves-effect waves-themed",
            "data-panel-setstyle": "bg-primary-500 bg-info-gradient",
            style: {"margin":"1px"}
          }),
          /*#__PURE__*/_createElementVNode("a", {
            href: "#",
            class: "btn d-inline-block bg-primary-600 bg-primary-gradient width-2 height-2 p-0 rounded-0 js-panel-color hover-effect-dot waves-effect waves-themed",
            "data-panel-setstyle": "bg-primary-600 bg-primary-gradient",
            style: {"margin":"1px"}
          }),
          /*#__PURE__*/_createElementVNode("a", {
            href: "#",
            class: "btn d-inline-block bg-info-600 bg-primray-gradient width-2 height-2 p-0 rounded-0 js-panel-color hover-effect-dot waves-effect waves-themed",
            "data-panel-setstyle": "bg-info-600 bg-primray-gradient",
            style: {"margin":"1px"}
          }),
          /*#__PURE__*/_createElementVNode("a", {
            href: "#",
            class: "btn d-inline-block bg-info-600 bg-info-gradient width-2 height-2 p-0 rounded-0 js-panel-color hover-effect-dot waves-effect waves-themed",
            "data-panel-setstyle": "bg-info-600 bg-info-gradient",
            style: {"margin":"1px"}
          }),
          /*#__PURE__*/_createElementVNode("a", {
            href: "#",
            class: "btn d-inline-block bg-info-700 bg-success-gradient width-2 height-2 p-0 rounded-0 js-panel-color hover-effect-dot waves-effect waves-themed",
            "data-panel-setstyle": "bg-info-700 bg-success-gradient",
            style: {"margin":"1px"}
          }),
          /*#__PURE__*/_createElementVNode("a", {
            href: "#",
            class: "btn d-inline-block bg-success-900 bg-info-gradient width-2 height-2 p-0 rounded-0 js-panel-color hover-effect-dot waves-effect waves-themed",
            "data-panel-setstyle": "bg-success-900 bg-info-gradient",
            style: {"margin":"1px"}
          }),
          /*#__PURE__*/_createElementVNode("a", {
            href: "#",
            class: "btn d-inline-block bg-success-700 bg-primary-gradient width-2 height-2 p-0 rounded-0 js-panel-color hover-effect-dot waves-effect waves-themed",
            "data-panel-setstyle": "bg-success-700 bg-primary-gradient",
            style: {"margin":"1px"}
          }),
          /*#__PURE__*/_createElementVNode("a", {
            href: "#",
            class: "btn d-inline-block bg-success-600 bg-success-gradient width-2 height-2 p-0 rounded-0 js-panel-color hover-effect-dot waves-effect waves-themed",
            "data-panel-setstyle": "bg-success-600 bg-success-gradient",
            style: {"margin":"1px"}
          }),
          /*#__PURE__*/_createElementVNode("a", {
            href: "#",
            class: "btn d-inline-block bg-danger-900 bg-info-gradient width-2 height-2 p-0 rounded-0 js-panel-color hover-effect-dot waves-effect waves-themed",
            "data-panel-setstyle": "bg-danger-900 bg-info-gradient",
            style: {"margin":"1px"}
          }),
          /*#__PURE__*/_createElementVNode("a", {
            href: "#",
            class: "btn d-inline-block bg-fusion-400 bg-fusion-gradient width-2 height-2 p-0 rounded-0 js-panel-color hover-effect-dot waves-effect waves-themed",
            "data-panel-setstyle": "bg-fusion-400 bg-fusion-gradient",
            style: {"margin":"1px"}
          }),
          /*#__PURE__*/_createElementVNode("a", {
            href: "#",
            class: "btn d-inline-block bg-faded width-2 height-2 p-0 rounded-0 js-panel-color hover-effect-dot waves-effect waves-themed",
            "data-panel-setstyle": "bg-faded",
            style: {"margin":"1px"}
          })
        ])
      ]),
      /*#__PURE__*/_createElementVNode("div", { class: "dropdown-divider m-0" }),
      /*#__PURE__*/_createElementVNode("a", {
        href: "#",
        class: "dropdown-item js-panel-reset"
      }, [
        /*#__PURE__*/_createElementVNode("span", { "data-i18n": "drpdwn.resetpanel" }, "Reset Panel")
      ])
    ])
  ])
], -1)
const _hoisted_17 = { class: "panel-container show" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { class: "loader" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fal fa-spinner-third fa-spin-4x fs-xxl" })
], -1)
const _hoisted_19 = { class: "panel-content" }
const _hoisted_20 = { class: "frame-wrap" }
const _hoisted_21 = { class: "demo" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("div", { class: "panel-tag" }, " ボタンを押すとパネル単位のローダーを表示して、処理を開始し、処理が完了するとローダーを消す。 ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _hoisted_8,
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, [
                  _hoisted_13,
                  _createElementVNode("button", {
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showLoader())),
                    id: "btn1",
                    class: "btn btn-primary waves-effect waves-themed"
                  }, " 処理実行 ")
                ])
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("div", _hoisted_15, [
          _hoisted_16,
          _createElementVNode("div", _hoisted_17, [
            _hoisted_18,
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("div", _hoisted_20, [
                _createElementVNode("div", _hoisted_21, [
                  _hoisted_22,
                  _createElementVNode("button", {
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showLoader4panel())),
                    id: "btn2",
                    class: "btn btn-primary waves-effect waves-themed"
                  }, " 処理実行 ")
                ])
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}